import styled from '@emotion/styled';
import { SvgBackground } from '../backgrounds';
import { Container } from '../organisms';
import { Heading, Text, Box } from '@theme-ui/components';

export const OrangeTxt = styled(Text)`
  color: #ea7926;
`;

export const StyledHeading = styled(Heading)`
  font-size: 2.5rem;
  line-height: 49.6px;
  text-align: left;
  font-weight: 300;
  @media (max-width: 768px) {
    font-size: 1.5rem;
    line-height: 31px;
  }
  @media (max-width: 639px) {
    text-align: center;
  }
`;

export const WrapperContainer = ({
  backgroundColor,
  backgroundSvgName,
  children,
}) => {

  backgroundColor = backgroundColor || '#FFFFFF';

  if (backgroundSvgName) {
    return (
      <SvgBackground bg={backgroundSvgName} bgColor={backgroundColor}>
        <Container>{children}</Container>
      </SvgBackground>
    );
  }

  return (
    <Box sx={{ bg: backgroundColor }}>
      <Container>{children}</Container>
    </Box>
  );
};
